<template>
  <section class="incellderm-sns">
    <sns-title />
    <sns-btn />
    <b-container class="swiper-container slide5 mt-8">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in instaList" :key="item.instagramUrl">
          <a :href="item.instagramUrl" class="btn" target="_blank">
            <img :src="item.thumbnailUrl" class="img" alt="" />
          </a>
        </div>

      </div>
    </b-container>
  </section>
</template>

<script>
import SnsBtn from './SnsBtn.vue';
import SnsTitle from './SnsTitle.vue';

export default {
  name: 'SnsSection',
  components: {
    SnsBtn,
    SnsTitle,
  },
  props: {
    instaList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
